import { Injectable } from '@angular/core';
import { UsersService } from '../users/users.service';

@Injectable({
  providedIn: 'root'
})
export class PrivilegesService {

  // 0 - brak dostępu
  // 1 - dostęp ograniczony
  // 2 - dostęp do wszystkiego

  userRole;

  privilagesEventType = {
    'training': {
      'event': {
        'check_presence': 2, // sprawdź listę obecności
        'edit': 2, // edytuj
        'cancel': 2, // odwołaj
        'close': 2, // zamknij
        'discard': 2, // odrzuć
        'accept': 2, // akceptuj
        'delete': 2 // usuń
      },
    },
    'outside_distributor': {
      'event': {
        'check_presence': 2, // sprawdź listę obecności
        'edit': 2, // edytuj
        'cancel': 2, // odwołaj
        'close': 2, // zamknij
        'discard': 2, // odrzuć
        'accept': 2, // akceptuj
        'delete': 2 // usuń
      },
    },
    'masterclass': {
      'event': {
        'check_presence': 2, // sprawdź listę obecności
        'edit': 2, // edytuj
        'cancel': 2, // odwołaj
        'close': 2, // zamknij
        'discard': 2, // odrzuć
        'accept': 2, // akceptuj
        'delete': 2 // usuń
      },
    },
    'trade_meeting': {
      'event': {
        'check_presence': 1, // sprawdź listę obecności
        'edit': 2, // edytuj
        'cancel': 2, // odwołaj
        'close': 0, // zamknij
        'discard': 0, // odrzuć
        'accept': 0, // akceptuj
        'delete': 2 // usuń
      },
    },
    'education_meeting': {
      'event': {
        'check_presence': 0, // sprawdź listę obecności
        'edit': 2, // edytuj
        'cancel': 2, // odwołaj
        'close': 0, // zamknij
        'discard': 2, // odrzuć
        'accept': 2, // akceptuj
        'delete': 2 // usuń
      },
    },
    'influential_event': {
      'event': {
        'check_presence': 0, // sprawdź listę obecności
        'edit': 2, // edytuj
        'cancel': 2, // odwołaj
        'close': 0, // zamknij
        'discard': 2, // odrzuć
        'accept': 2, // akceptuj
        'delete': 2 // usuń
      },
    },
    'salon_training': {
      'event': {
        'check_presence': 2, // sprawdź listę obecności
        'edit': 2, // edytuj
        'cancel': 2, // odwołaj
        'close': 2, // zamknij
        'discard': 0, // odrzuć
        'accept': 0, // akceptuj
        'delete': 2 // usuń
      },
      'student': {
        'add': 2,
        'book': 2,
        'check_presence': 2,
        'delete': 2,
        'edit': 2
      },
    },
    'terrain_visit': {
      'event': {
        'check_presence': 0, // sprawdź listę obecności
        'edit': 2, // edytuj
        'cancel': 2, // odwołaj
        'close': 0, // zamknij
        'discard': 0, // odrzuć
        'accept': 0, // akceptuj
        'delete': 2 // usuń
      },
    },
    'other': {
      'event': {
        'check_presence': 0, // sprawdź listę obecności
        'edit': 2, // edytuj
        'cancel': 0, // odwołaj
        'close': 0, // zamknij
        'discard': 0, // odrzuć
        'accept': 0, // akceptuj
        'delete': 2 // usuń
      },
    },
    'salon_training_paid': {
      'event': {
        'check_presence': 2, // sprawdź listę obecności
        'edit': 2, // edytuj
        'cancel': 2, // odwołaj
        'close': 2, // zamknij
        'discard': 0, // odrzuć
        'accept': 0, // akceptuj
        'delete': 2 // usuń
      },
      'student': {
        'add': 2,
        'book': 2,
        'check_presence': 2,
        'delete': 2,
        'edit': 2
      },
    },
    'salon_training_turnover': {
      'event': {
        'check_presence': 2, // sprawdź listę obecności
        'edit': 2, // edytuj
        'cancel': 2, // odwołaj
        'close': 2, // zamknij
        'discard': 0, // odrzuć
        'accept': 0, // akceptuj
        'delete': 2 // usuń
      },
      'student': {
        'add': 2,
        'book': 2,
        'check_presence': 2,
        'delete': 2,
        'edit': 2
      },
    },
  };

  privilagetEventStatus = {
    'new': {
      'event': { // WYDARZENIE
        'check_presence': 0, // sprawdź listę obecności
        'edit': 2, // edytuj
        'cancel': 2, // odwołaj
        'close': 0, // zamknij
        'discard': 0, // odrzuć
        'accept': 0, // akceptuj
        'delete': 2 // usuń
      },
      'student': { // KURSANT
        'add': 0, // dodaj kursanta
        'book': 0, // reserwuj miejsce
        'check_presence': 0, // oznacz obecność
        'delete': 0, // usuń
        'edit': 0 // edytuj
      },
      'salon': { // SALON
        'delete': 0 // usuń
      }
    },
    'accept_by_instructor': {
      'event': { // WYDARZENIE
        'check_presence': 0, // sprawdź listę obecności
        'edit': 2, // edytuj
        'cancel': 2, // odwołaj
        'close': 0, // zamknij
        'discard': 2, // odrzuć
        'accept': 2, // akceptuj
        'delete': 0 // usuń
      },
      'student': { // KURSANT
        'add': 0, // dodaj kursanta
        'book': 0, // reserwuj miejsce
        'check_presence': 0, // oznacz obecność
        'delete': 0, // usuń
        'edit': 0 // edytuj
      },
      'salon': { // SALON
        'delete': 0 // usuń
      }
    },
    'accepted_by_instructor': {
      'event': { // WYDARZENIE
        'check_presence': 0, // sprawdź listę obecności
        'edit': 2, // edytuj
        'cancel': 2, // odwołaj
        'close': 0, // zamknij
        'discard': 2, // odrzuć
        'accept': 0, // akceptuj
        'delete': 0 // usuń
      },
      'student': { // KURSANT
        'add': 0, // dodaj kursanta
        'book': 0, // reserwuj miejsce
        'check_presence': 0, // oznacz obecność
        'delete': 0, // usuń
        'edit': 0 // edytuj
      },
      'salon': { // SALON
        'delete': 0 // usuń
      }
    },
    'rejected_by_instructor': {
      'event': { // WYDARZENIE
        'check_presence': 0, // sprawdź listę obecności
        'edit': 2, // edytuj
        'cancel': 2, // odwołaj
        'close': 0, // zamknij
        'discard': 0, // odrzuć
        'accept': 2, // akceptuj
        'delete': 0 // usuń
      },
      'student': { // KURSANT
        'add': 0, // dodaj kursanta
        'book': 0, // reserwuj miejsce
        'check_presence': 0, // oznacz obecność
        'delete': 0, // usuń
        'edit': 0 // edytuj
      },
      'salon': { // SALON
        'delete': 0 // usuń
      }
    },
    'published': {
      'event': { // WYDARZENIE
        'check_presence': 2, // sprawdź listę obecności
        'edit': 0, // edytuj
        'cancel': 2, // odwołaj
        'close': 2, // zamknij
        'discard': 0, // odrzuć
        'accept': 0, // akceptuj
        'delete': 0 // usuń
      },
      'student': { // KURSANT
        'add': 2, // dodaj kursanta
        'book': 2, // reserwuj miejsce
        'check_presence': 2, // oznacz obecność
        'delete': 2, // usuń
        'edit': 2 // edytuj
      },
      'salon': { // SALON
        'delete': 2 // usuń
      }
    },
    'finished': {
      'event': { // WYDARZENIE
        'check_presence': 2, // sprawdź listę obecności
        'edit': 0, // edytuj
        'cancel': 0, // odwołaj
        'close': 0, // zamknij
        'discard': 0, // odrzuć
        'accept': 0, // akceptuj
        'delete': 0 // usuń
      },
      'student': { // KURSANT
        'add': 2, // dodaj kursanta
        'book': 0, // reserwuj miejsce
        'check_presence': 2, // oznacz obecność
        'delete': 2, // usuń
        'edit': 2 // edytuj
      },
      'salon': { // SALON
        'delete': 0 // usuń
      }
    },
    'cancelled': {
      'event': { // WYDARZENIE
        'check_presence': 0, // sprawdź listę obecności
        'edit': 0, // edytuj
        'cancel': 0, // odwołaj
        'close': 0, // zamknij
        'discard': 0, // odrzuć
        'accept': 0, // akceptuj
        'delete': 0 // usuń
      },
      'student': { // KURSANT
        'add': 0, // dodaj kursanta
        'book': 0, // reserwuj miejsce
        'check_presence': 0, // oznacz obecność
        'delete': 0, // usuń
        'edit': 0 // edytuj
      },
      'salon': { // SALON
        'delete': 0 // usuń
      }
    },
    'cancelled_frequency': {
      'event': { // WYDARZENIE
        'check_presence': 0, // sprawdź listę obecności
        'edit': 0, // edytuj
        'cancel': 0, // odwołaj
        'close': 0, // zamknij
        'discard': 0, // odrzuć
        'accept': 0, // akceptuj
        'delete': 0 // usuń
      },
      'student': { // KURSANT
        'add': 0, // dodaj kursanta
        'book': 0, // reserwuj miejsce
        'check_presence': 0, // oznacz obecność
        'delete': 0, // usuń
        'edit': 0 // edytuj
      },
      'salon': { // SALON
        'delete': 0 // usuń
      }
    },
    'cancelled_disease': {
      'event': { // WYDARZENIE
        'check_presence': 0, // sprawdź listę obecności
        'edit': 0, // edytuj
        'cancel': 0, // odwołaj
        'close': 0, // zamknij
        'discard': 0, // odrzuć
        'accept': 0, // akceptuj
        'delete': 0 // usuń
      },
      'student': { // KURSANT
        'add': 0, // dodaj kursanta
        'book': 0, // reserwuj miejsce
        'check_presence': 0, // oznacz obecność
        'delete': 0, // usuń
        'edit': 0 // edytuj
      },
      'salon': { // SALON
        'delete': 0 // usuń
      }
    },
    'removed': {
      'event': { // WYDARZENIE
        'check_presence': 0, // sprawdź listę obecności
        'edit': 0, // edytuj
        'cancel': 0, // odwołaj
        'close': 0, // zamknij
        'discard': 0, // odrzuć
        'accept': 0, // akceptuj
        'delete': 0 // usuń
      },
      'student': { // KURSANT
        'add': 0, // dodaj kursanta
        'book': 0, // reserwuj miejsce
        'check_presence': 0, // oznacz obecność
        'delete': 0, // usuń
        'edit': 0 // edytuj
      },
      'salon': { // SALON
        'delete': 0 // usuń
      }
    }
  };

  privilegesRole = {
    'ROLE_SUPER_ADMIN': {
      'event': {
        'check_presence': 2, // sprawdź listę obecności
        'edit': 2, // edytuj
        'cancel': 2, // odwołaj
        'close': 2, // zamknij
        'discard': 2, // odrzuć
        'accept': 2, // akceptuj
        'delete': 2 // usuń
      },
      'student': {
        'add': 2,
        'book': 1,
        'check_presence': 2,
        'delete': 2,
        'edit': 2
      },
      'salon': {
        'delete': 2
      }
    },
    'ROLE_ADMIN': {
      'event': {
        'check_presence': 2, // sprawdź listę obecności
        'edit': 2, // edytuj
        'cancel': 2, // odwołaj
        'close': 2, // zamknij
        'discard': 2, // odrzuć
        'accept': 2, // akceptuj
        'delete': 2 // usuń
      },
      'student': {
        'add': 2,
        'book': 1,
        'check_presence': 2,
        'delete': 2,
        'edit': 2
      },
      'salon': {
        'delete': 2
      }
    },
    'ROLE_COORDINATOR': {
      'event': {
        'check_presence': 2, // sprawdź listę obecności
        'edit': 2, // edytuj
        'cancel': 2, // odwołaj
        'close': 2, // zamknij
        'discard': 2, // odrzuć
        'accept': 2, // akceptuj
        'delete': 2 // usuń
      },
      'student': {
        'add': 2,
        'book': 1,
        'check_presence': 2,
        'delete': 2,
        'edit': 2
      },
      'salon': {
        'delete': 2
      }
    },
    'ROLE_SALES_REPRESENTATIVE': {
      'event': {
        'check_presence': 2, // sprawdź listę obecności
        'edit': 0, // edytuj
        'cancel': 0, // odwołaj
        'close': 0, // zamknij
        'discard': 0, // odrzuć
        'accept': 0, // akceptuj
        'delete': 0 // usuń
      },
      'student': {
        'add': 0,
        'book': 2,
        'check_presence': 0,
        'delete': 1,
        'edit': 0
      },
      'salon': {
        'delete': 0
      }
    },
    'ROLE_DISTRIBUTOR': {
      'event': {
        'check_presence': 2, // sprawdź listę obecności
        'edit': 0, // edytuj
        'cancel': 0, // odwołaj
        'close': 0, // zamknij
        'discard': 0, // odrzuć
        'accept': 0, // akceptuj
        'delete': 0 // usuń
      },
      'student': {
        'add': 0,
        'book': 0,
        'check_presence': 0,
        'delete': 2,
        'edit': 0
      },
      'salon': {
        'delete': 2
      }
    },
    'ROLE_INSTRUCTOR': {
      'event': {
        'check_presence': 1, // sprawdź listę obecności
        'edit': 0, // edytuj
        'cancel': 0, // odwołaj
        'close': 2, // zamknij
        'discard': 2, // odrzuć
        'accept': 2, // akceptuj
        'delete': 0 // usuń
      },
      'student': {
        'add': 2,
        'book': 0,
        'check_presence': 2,
        'delete': 2,
        'edit': 2
      },
      'salon': {
        'delete': 2
      }
    },
    'ROLE_EMPLOYEE': {
      'event': {
        'check_presence': 0, // sprawdź listę obecności
        'edit': 0, // edytuj
        'cancel': 0, // odwołaj
        'close': 0, // zamknij
        'discard': 0, // odrzuć
        'accept': 0, // akceptuj
        'delete': 0 // usuń
      },
      'student': {
        'add': 0,
        'book': 0,
        'check_presence': 0,
        'delete': 0,
        'edit': 0
      },
      'salon': {
        'delete': 0
      }
    }
  };

  constructor(
    private usersService: UsersService,
  ) {
    this.userRole = this.usersService.me.role;
   }

  hasAccessRole(element, action) {
    if (this.privilegesRole[this.userRole][element]) {
      return this.privilegesRole[this.userRole][element][action];
    }
    return 3;
  }

  hasAccessEventStatus(status, element, action) {
    if (this.privilagetEventStatus[status][element]) {
      return this.privilagetEventStatus[status][element][action];
    }
    return 3;
  }

  hasAccessEventType(type, element, action) {

    if (this.privilagesEventType[type][element]) {
      return this.privilagesEventType[type][element][action];
    }
    return 3;
  }
}
